"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Usage = void 0;
const react_1 = __importStar(require("react"));
const Usage = ({ usageList }) => {
    const usageByMonth = (0, react_1.useMemo)(() => {
        const usageByMonth = {};
        for (const usageData of usageList) {
            for (const platformKey of ["openai"]) {
                const platform = usageData[platformKey];
                for (const model of Object.keys(platform)) {
                    const tokens = usageData.openai[model].prompt_tokens +
                        usageData.openai[model].completion_tokens;
                    usageByMonth[usageData.month] =
                        (usageByMonth[usageData.month] || 0) + tokens;
                }
            }
        }
        return Object.keys(usageByMonth)
            .sort()
            .reverse()
            .map((month) => ({
            month,
            usage: usageByMonth[month],
        }));
    }, [usageList]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h2", { style: {
                fontSize: "1.5rem",
                marginTop: "2rem",
                marginBottom: "1rem",
            } }, "\u4F7F\u7528\u72B6\u6CC1"),
        react_1.default.createElement("table", { className: "common-table table is-striped is-hoverable" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, "\u6708"),
                    react_1.default.createElement("th", null, "\u4F7F\u7528\u30C8\u30FC\u30AF\u30F3\u6570"))), usageByMonth === null || usageByMonth === void 0 ? void 0 :
            usageByMonth.map(({ month, usage }) => (react_1.default.createElement("tr", { key: month },
                react_1.default.createElement("td", null, month),
                react_1.default.createElement("td", null, usage)))))));
};
exports.Usage = Usage;
